var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectorsicon3504D1Be(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F5F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.58 11.778v16.11h-6.472v-16.11h6.472ZM19.353 9H7.334v21.667h12.02V9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.58 11.778v16.11h-6.472v-16.11h6.472ZM19.353 9H7.334v21.667h12.02V9Z",
    fill: "url(#b)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.58 11.778v16.11h-6.472v-16.11h6.472ZM19.353 9H7.334v21.667h12.02V9Z",
    fill: "url(#c)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.668 9h-12.02v8.889h12.02V9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.668 9h-12.02v8.889h12.02V9Z",
    fill: "url(#d)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.668 9h-12.02v8.889h12.02V9Z",
    fill: "url(#e)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.894 22.332v5.556h-6.472v-5.556h6.472Zm2.774-2.777h-12.02v11.11h12.02v-11.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.894 22.332v5.556h-6.472v-5.556h6.472Zm2.774-2.777h-12.02v11.11h12.02v-11.11Z",
    fill: "url(#f)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.894 22.332v5.556h-6.472v-5.556h6.472Zm2.774-2.777h-12.02v11.11h12.02v-11.11Z",
    fill: "url(#g)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.353,
    y1: 30.667,
    x2: 0.971,
    y2: 20.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 7.334,
    y1: 9,
    x2: 25.551,
    y2: 19.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 32.668,
    y1: 17.889,
    x2: 24.169,
    y2: 6.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 20.648,
    y1: 9,
    x2: 28.939,
    y2: 20.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 32.668,
    y1: 30.666,
    x2: 21.591,
    y2: 18.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 20.648,
    y1: 19.555,
    x2: 31.498,
    y2: 31.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.334 9)",
    d: "M0 0h25.333v21.667H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorsicon3504D1Be);
export default __webpack_public_path__ + "static/media/sectorsicon.3504d1be.7a1e20e5e116ef9cddbe5c393d69c2fd.svg";
export { ForwardRef as ReactComponent };